module.exports = __webpack_public_path__ + "static/media/login.e20863bf.jpeg";